<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ title }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" class="scheduleHourForm" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      @if (!isAdd) {
        <mat-form-field class="flex-full">
          <mat-label>Day Of Week</mat-label>
          <input
            autocomplete="off"
            type="text"
            formControlName="dayOfWeek"
            [name]="'dayOfWeek'"
            ndtDayOfWeekSelect
            [lcsSingleSelect]="dayOfWeekSelect"
            />
            <ndt-day-of-week-select #dayOfWeekSelect></ndt-day-of-week-select>
          </mat-form-field>
        }
        @if (
          form.get('selectedDays')?.hasError('invalidDayOfWeek') ||
          form.get('dayOfWeek')?.hasError('invalidDayOfWeek')
          ) {
          <mat-error
            >At least one day is required.</mat-error
            >
        }
        @if (isAdd) {
          <div>
            <br />
            @for (day of daysOfWeekArray; track day) {
              <mat-checkbox
                class="checkbox-margin"
                (change)="onCheckboxChange(day.value)"
                >{{ day.name }}</mat-checkbox
                >
              }
            </div>
          }
          <br />
          <div class="detail-right-column">
            @if (isSafari()) {
              <div class="segmented-timepicker-wrapper flex-half">
                <ndt-segmented-timepicker
                  [required]="true"
                  label="Open Time"
                  formControlName="openTime"
                ></ndt-segmented-timepicker>
                @if (form.get('openTime')?.touched && form.get('openTime')?.invalid) {
                  <div
                    class="segmented-timepicker-error"
                    >
                    @if (form.get('openTime')?.hasError('required')) {
                      <span>Open Time is required.</span>
                    }
                    @if (form.get('openTime')?.hasError('invalidTimeRange')) {
                      <span
                        >Open Time should be before Close Time.</span
                        >
                      }
                    </div>
                  }
                </div>
                <div class="segmented-timepicker-wrapper flex-half">
                  <ndt-segmented-timepicker
                    [required]="true"
                    label="Close Time"
                    formControlName="closeTime"
                  ></ndt-segmented-timepicker>
                  @if (form.get('closeTime')?.touched && form.get('closeTime')?.invalid) {
                    <div
                      class="segmented-timepicker-error"
                      >
                      @if (form.get('closeTime')?.hasError('required')) {
                        <span>Close Time is required.</span>
                      }
                      @if (form.get('closeTime')?.hasError('invalidTimeRange')) {
                        <span
                          >Close Time should be after Open Time.</span
                          >
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <mat-form-field class="flex-half field-padding-right">
                    <mat-label>Open Time</mat-label>
                    <input
                      matInput
                      type="time"
                      autocomplete="off"
                      formControlName="openTime"
                      [name]="'openTime'"
                      required
                      />
                      @if (form.get('openTime')?.hasError('required')) {
                        <mat-error> Open Time is Required. </mat-error>
                      }
                      @if (form.get('openTime')?.hasError('invalidTimeRange')) {
                        <mat-error
                          >Open Time should be before Close Time.</mat-error
                          >
                      }
                    </mat-form-field>
                    <mat-form-field class="flex-half">
                      <mat-label>Close Time</mat-label>
                      <input
                        matInput
                        type="time"
                        autocomplete="off"
                        formControlName="closeTime"
                        [name]="'closeTime'"
                        required
                        />
                        @if (form.get('closeTime')?.hasError('required')) {
                          <mat-error> Close Time is Required. </mat-error>
                        }
                        @if (form.get('closeTime')?.hasError('invalidTimeRange')) {
                          <mat-error
                            >Close Time should be after Open Time.</mat-error
                            >
                        }
                      </mat-form-field>
                    }
                  </div>
                </mat-dialog-content>
                <mat-dialog-actions>
                  <button type="submit" title="Create" mat-raised-button>Save</button>
                </mat-dialog-actions>
              </form>
            </lcs-loading-overlay>
